export function sortObjectArray(items, key, val, forceNumbers) {
  if (!items) {
    return items;
  }

  items.sort((a, b) => {
    let comparator = null;

    if (typeof a[key] === 'string') {
      comparator = compareString;
    } else if (typeof a[key] === 'number') {
      comparator = compareNumber;
    }

    if (comparator === null) {
      return 0;
    }

    if (forceNumbers && typeof a[key] === 'number' && typeof b[key] !== 'number') {
      return -1;
    }

    if (forceNumbers && typeof a[key] !== 'number' && typeof b[key] === 'number') {
      return 1;
    }

    return val === 1 ? comparator(a[key], b[key]) : comparator(b[key], a[key]);
  });

  return items;
}

function compareString(a, b) {
  if (!a) {
    return 1;
  }

  return a.localeCompare(b);
}

function compareNumber(a, b) {
  return a - b;
}
